import React, { HTMLAttributes } from 'react';

import { IColumn } from '../interfaces';
import './Column.scss';
interface IColumnSort extends IColumn {
  name: string;
  isActive?: boolean;
  isAscending?: boolean;
  isSortable?: boolean;
  sort: any;
}

export const TableColumn: React.FC<IColumnSort> = React.memo(
  ({ name, isSortable = false, isActive = false, isAscending, sort }) => {
    const headerColumnAttributes: HTMLAttributes<HTMLTableHeaderCellElement> = {
      className: 'table-column',
    };
    if (isSortable) {
      headerColumnAttributes.onClick = sort;
      headerColumnAttributes.className = isActive
        ? 'active sortable table-column'
        : 'sortable table-column';
    }
    return (
      <th {...headerColumnAttributes}>
        <span>{name}</span>
        <span className='header-sort-icon'>
          {isActive ? (
            <i
              className={
                isAscending
                  ? 'fas fa-arrow-up mr-2 fcolor--primary-brand'
                  : 'fas fa-arrow-down mr-2 fcolor--primary-brand'
              }
            ></i>
          ) : null}
        </span>
      </th>
    );
  }
);
